export * from './marketplace-roof';
export * from './warehouse-roof';
export * from './catalog-roof';
export * from './space-config-roof';
export * from './totalizer-roof';
export * from './monitor-roof';
export * from './management-roof';
export * from './dummy-roof';
export * from './library-roof';

import { DummyRoofComponent } from './dummy-roof';
import { CatalogRoofComponent } from './catalog-roof';
import { LibraryRoofComponent } from './library-roof';
import { ManagementRoofComponent } from './management-roof';
import { MarketplaceRoofComponent } from './marketplace-roof';
import { MonitorRoofComponent } from './monitor-roof';
import { SpaceConfigRoofComponent } from './space-config-roof';
import { TotalizerRoofComponent } from './totalizer-roof';
import { WarehouseRoofComponent } from './warehouse-roof';

export const BuildingMolecules = [
    MarketplaceRoofComponent,
    WarehouseRoofComponent,
    CatalogRoofComponent,
    SpaceConfigRoofComponent,
    TotalizerRoofComponent,
    MonitorRoofComponent,
    ManagementRoofComponent,
    DummyRoofComponent,
    LibraryRoofComponent
];